export default __webpack_public_path__ + "static/media/Caliginous Gridle.b4252499.jpg";